import * as GQL from "src/types/graphql";

const EXCLUDED_FORM_STATUSES = [
  GQL.form_status_enum.Cancelled,
  GQL.form_status_enum.InProgress,
];

type FormSchoolRank = {
  sub_status: string | null;
  form: { status: GQL.form_status_enum };
  offers: { status: GQL.offer_status_enum }[];
};

type FormSchool = {
  schoolId: uuid | null;
};

export function canMakeOffers(
  formSchoolRanks: FormSchoolRank[],
  formSchools: FormSchool[],
  isAllowedSubStatus?: (subStatus: string | null) => boolean
): boolean {
  if (formSchools.some((appSchool) => !appSchool.schoolId)) {
    return false;
  }

  return formSchoolRanks.every((rank) => {
    if (EXCLUDED_FORM_STATUSES.includes(rank.form.status)) return false;
    if (isAllowedSubStatus && !isAllowedSubStatus(rank.sub_status))
      return false;

    if (
      rank.offers[0]?.status === GQL.offer_status_enum.Offered ||
      rank.offers[0]?.status === GQL.offer_status_enum.Accepted
    )
      return false;

    return true;
  });
}
